import { render, staticRenderFns } from "./PriceByProviderTable.vue?vue&type=template&id=09e1c4f0&scoped=true&"
import script from "./PriceByProviderTable.vue?vue&type=script&lang=js&"
export * from "./PriceByProviderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e1c4f0",
  null
  
)

export default component.exports